import Apicall from "../api/Apicall";
import { Context } from "../components/containers/context/Context";
import {useContext} from "react";

export const useEmpresas = ({ app }) => {

    const {user} = useContext(Context);

    const consultarEmpresasAdministrador = async ({setData}) => {

        const result = await Apicall({
            url: `${app.url}/user/getEmpresasAdministrador`, user, app
        });

        if ( result?.data?.success === true) {
            console.log("correcto");
        }

        if(result?.data?.data && setData) {
            setData(result.data.data);
        }

    }

    return {
        consultarEmpresasAdministrador
    };
    
};